import React from "react";
import { Sparkles } from "lucide-react";

export default function ComingSoon({ toolName }) {
  return (
    <div className="rounded-2xl border-2 border-dashed border-slate-300 dark:border-white/15 p-12 text-center bg-slate-50/50 dark:bg-[#0b0c0e]">
      <div className="w-14 h-14 mx-auto rounded-2xl bg-blue-50 dark:bg-blue-500/10 text-blue-600 dark:text-blue-400 grid place-items-center">
        <Sparkles size={22} />
      </div>
      <h3 className="mt-5 text-lg font-semibold text-slate-900 dark:text-white">{toolName || "This tool"} is coming soon</h3>
      <p className="mt-2 text-sm text-slate-500 dark:text-slate-400 max-w-md mx-auto">
        We're polishing this experience. Meanwhile, explore our other production-ready tools below.
      </p>
    </div>
  );
}
